module.exports = __webpack_public_path__ + "img/logo.10e7b9e8.png";